var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"crly-m-common-slide-menu-item",class:_vm.menuItem.type,on:{"click":_vm.clickSlideMenuItem}},[(_vm.isChild)?_c('span',{staticClass:"crly-m-common-slide-menu-item__child-icon"}):_vm._e(),_c('label',[_vm._v(_vm._s(_vm.menuItem.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }